module.exports = __webpack_public_path__ + "static/media/andere-handtuecher.2154590e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/andere-handtuecher.png
// module id = 136
// module chunks = 0